import React from 'react'
import Dropdown, { DropdownItem } from '../Components/Dropdown';
import { Input } from '../Components/Input';
import { Icons } from '../constants';
import { LocalizedText } from '../language';
import { RelatedParticipant, NewBlankRelatedParticipant } from '../Models/participant';
import { ValidationMessages } from '../Models/system';

export interface AdditionalParticipantRowProps {
	relatedParticipants: Array<RelatedParticipant>
	additionalParticipant?: RelatedParticipant
	localizedText: LocalizedText
	additionalParticipantChanged: (additionalParticipant?: RelatedParticipant) => void
	validationMessages?: ValidationMessages<RelatedParticipant>
}

export function AdditionalParticipantRow(props: AdditionalParticipantRowProps) {

	if (!props.additionalParticipant) return null

	const handleDeleteAdditionalParticipant = () => {
		props.additionalParticipantChanged(undefined)
	}

	const handleChangeExistingParticipantDropdown = (registrationId?: number) => {
		if (registrationId && registrationId > 0) {
			const existingParticipant = props.relatedParticipants.find(rp => rp.RegistrationId == registrationId)!
			props.additionalParticipantChanged(existingParticipant)
		}
		else {
			props.additionalParticipantChanged(Object.assign({}, NewBlankRelatedParticipant))
		}
	}

	const getParticipantNameChangedHandler = (nameType: 'NameFirst' | 'NameLast') => {
		return (name: string) => {
			const newParticipant = Object.assign({}, props.additionalParticipant)!
			newParticipant[nameType] = name
			props.additionalParticipantChanged(newParticipant)
		}
	}

	const deleteButton =
		<div className='column is-1'>
			<label className='label'>{props.localizedText.Remove}</label>
			<button className='button is-danger' title={props.localizedText.RemoveParticipant} onClick={handleDeleteAdditionalParticipant}>{Icons.x}</button>
		</div>

	const relatedParticipantDropdownItems: Array<DropdownItem<number>> = props.relatedParticipants.map(rp => {
		return {
			value: rp.RegistrationId,
			text: `${rp.NameFirst} ${rp.NameLast}`
		}
	})

	// user can't change existing users' names
	const nameTextBoxesDisabled = props.additionalParticipant.RegistrationId > 0

	return (
		<div className='columns'>
			<Dropdown items={relatedParticipantDropdownItems} value={props.additionalParticipant.RegistrationId} isInColumn={true} 
				onChange={handleChangeExistingParticipantDropdown} label={props.localizedText.PreviousGuests} placeholder={props.localizedText.AddNew} disabled={props.relatedParticipants.length == 0} />
			<Input value={props.additionalParticipant.NameFirst} label={props.localizedText.FirstName} isInColumn={true} isRequired={true}
				onChange={getParticipantNameChangedHandler('NameFirst')} disabled={nameTextBoxesDisabled} errorMessage={props.validationMessages?.NameFirst} />
			<Input value={props.additionalParticipant.NameLast} label={props.localizedText.LastName} isInColumn={true} isRequired={true}
				onChange={getParticipantNameChangedHandler('NameLast')} disabled={nameTextBoxesDisabled} errorMessage={props.validationMessages?.NameLast} />
			{deleteButton}
		</div>

	)
}